import React from 'react';

export default function WelcomeModal({ onClose }) {
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal welcome-modal" onClick={(e) => e.stopPropagation()}>
        <div className="welcome-header">
          <h2>Bienvenue! 👋</h2>
        </div>

        <div className="welcome-content">
          <div className="welcome-icon">🚀</div>
          <p className="welcome-text">
            Bienvenue sur l'ensemble de mes applis et projets disponibles en ligne
          </p>
          <p className="welcome-subtitle">
            Explorez, ouvrez et gérez vos applications préférées depuis un seul tableau de bord
          </p>
        </div>

        <div className="welcome-features">
          <div className="feature-item">
            <span className="feature-icon">➕</span>
            <span>Ajoutez vos apps</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">🪟</span>
            <span>Ouvrez en fenêtres</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">✓</span>
            <span>Vérifiez les statuts</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">⌨️</span>
            <span>Raccourcis clavier</span>
          </div>
        </div>

        <div className="welcome-shortcuts">
          <h4>Raccourcis rapides</h4>
          <div className="shortcut-row">
            <kbd>Super</kbd>
            <span>ou</span>
            <kbd>Ctrl+A</kbd>
            <span>Afficher les apps</span>
          </div>
          <div className="shortcut-row">
            <kbd>Ctrl+`</kbd>
            <span>Ouvrir le terminal</span>
          </div>
        </div>

        <button className="btn btn-primary" onClick={onClose}>
          Commencer ✨
        </button>
      </div>
    </div>
  );
}
